import React, { PureComponent } from "react";

import Select from "react-select";

import { Button, ButtonGroup, Dropdown, Icon } from "aible";

import LoadingIndicactor from "components/LoadingIndicator/LoadingIndicator";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";

import styles from "./style.module.css";

export default class HeaderTab extends React.PureComponent {
  render() {
    const {
      label,
      isComplete,
      isLoading,
      completeLabel,
      showCheck,
      showWarn,
      title,
      active,
      disabled,
      highlightStep,
      stepId,
      selectStep,
      staticContext,
      isEditBlueprint,
      className,
      setup,
      ...retProps
    } = this.props;

    const retActive = active || highlightStep === stepId;

    return (
      <div
        className={
          styles.headerTabWrapper +
          " " +
          (retActive ? styles.active : "") +
          " " +
          (disabled ? styles.disabled : "") +
          " " +
          (isEditBlueprint ? styles.editBlueprint : "") +
          " " +
          (className ? className : "")
        }
        {...retProps}
      >
        <div className={styles.headerTabLabel} title={label}>
          {isLoading ? "" : isComplete === true && completeLabel !== undefined ? completeLabel : label}
        </div>
        <div className={styles.headerTabTitleWrapper}>
          {title === "Training..." ? (
            <LoadingIndicactor
              style={{
                margin: "0px",
                transform: "scale(0.25)",
                height: "12px",
                width: "0px",
                marginRight: "25px",
                marginTop: "-10px"
              }}
              color={active ? "white" : "#333"}
            />
          ) : showWarn ? (
            <div
              className={
                styles.headerTabIcon + " " + (retActive ? styles.active : "") + " " + (disabled ? styles.disabled : "")
              }
              style={{ border: "none" }}
            >
              {disabled || retActive ? "" : <FontAwesomeIcon icon={faExclamationTriangle} />}
            </div>
          ) : (
            <div
              className={
                styles.headerTabIcon +
                " " +
                (retActive ? styles.active : "") +
                " " +
                (disabled ? styles.disabled : "") +
                " " +
                (isEditBlueprint ? styles.editBlueprint : "")
              }
              style={{ opacity: showCheck ? 1 : 0 }}
            >
              {disabled || retActive ? (
                ""
              ) : (
                <Icon type={active || isEditBlueprint ? "check" : "checkPurple"} size={6} />
              )}
            </div>
          )}
          <div className={styles.headerTabTitle} title={title}>
            {title}
          </div>
        </div>
      </div>
    );
  }
}
